module.exports = __webpack_public_path__ + "img/veu.28b06593.svg";